import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SectionProgressState } from '../../../models/section-progress-state.interface';

@Component({
  standalone: true,
  selector: 'eiq-section-progress',
  templateUrl: 'section-progress.component.html',
  styleUrls: ['./section-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltipModule]
})
export class SectionProgressComponent {
  sections = input<SectionProgressState[]>([]);
  label = input<string>();
}
